import type { ZudokuConfig } from "zudoku";
import { BlogHome } from "../components/BlogHome";
import blogNav from "./blogNav.json";
import docsNav from "./docsNav.json";

const navigation: ZudokuConfig["navigation"] = [
  {
    type: "category",
    label: "Home",
    items: [
      {
        type: "category",
        label: "Blogs",
        icon: "book",
        items: [
          {
            type: "custom-page",
            path: "/",
            label: "Home",
            element: <BlogHome />,
            layout: "none",
          },
          ...(blogNav as any[]),
        ],
      },
    ],
  },
  ...(docsNav.length > 0
    ? [
        {
          type: "category" as const,
          label: "Docs",
          items: docsNav as any[],
        },
      ]
    : []),
  {
    type: "link",
    to: "/api",
    label: "API Playground",
  },
];

export default navigation;